module.exports = function getResource(label, vars = []) {
    const resources = {
        guestSavingsMessage: `Save ${vars[0]} annually with this subscription.`,
        signedInSavingsMessage: `${vars[0]}, save ${vars[1]} annually with this subscription.`
    };

    return resources[label];
};
